module.exports = __webpack_public_path__ + "img/arrow_right_2.6c0a6561.svg";